<div class="card" style="margin-bottom: 1rem; overflow-x: auto;">
  <table class="table is-fullwidth socios-titulo-table" aria-label="Socios por título">
    <thead>
      <tr>
        <th scope="col">Nombre</th>
        <th scope="col">NIF</th>
        <th scope="col" class="numeric-cell">Nº Acciones</th>
        <th scope="col">Título</th>
        <th scope="col" class="numeric-cell">Nº Acc. Ajustado</th>
        <th scope="col" class="numeric-cell">Total Acc. Ajustado</th>
        <th scope="col" class="numeric-cell">VN</th>
        <th scope="col" class="numeric-cell">% Participación</th>
        <th scope="col" class="center-cell">Presidente</th>
        <th scope="col" class="center-cell">Secretario</th>
        <th scope="col" class="center-cell">Socio Trabajador</th>
      </tr>
    </thead>
    <tbody (mouseleave)="onSociosTableBodyLeave()">
      @for (row of rows(); track row.socioIndex + '_' + row.titulo) {
        <tr
          class="socios-titulo-row"
          [class.socios-titulo-row-hovered]="hoveredSocioIndex() === row.socioIndex"
          style="cursor: pointer;"
          tabindex="0"
          (mouseenter)="onSocioRowEnter(row.socioIndex)"
          (click)="onRowClick(row.socio)"
          (keydown)="onRowKeydown($event, row.socio)"
        >
          @if (row.isFirst) {
            <td [attr.rowspan]="row.rowCount" style="vertical-align: middle;">{{ row.nombre }}</td>
            <td [attr.rowspan]="row.rowCount" style="vertical-align: middle;">{{ row.nif }}</td>
            <td [attr.rowspan]="row.rowCount" class="numeric-cell" style="vertical-align: middle;">
              {{ formatShareAmount(row.sharesCountNonUsuf) }}
            </td>
          }
          <td>{{ row.tituloLabel }}</td>
          <td class="numeric-cell">{{ formatAdjusted(row.sharesCountAdjustedForTitulo) }}</td>
          @if (row.isFirst) {
            <td [attr.rowspan]="row.rowCount" class="numeric-cell" style="vertical-align: middle;">
              <strong>{{ formatAdjusted(row.totalAdjusted) }}</strong>
            </td>
            <td [attr.rowspan]="row.rowCount" class="numeric-cell" style="vertical-align: middle;">
              {{ formatEuro(row.totalVn) }}
            </td>
            <td [attr.rowspan]="row.rowCount" class="numeric-cell" style="vertical-align: middle;">
              {{ row.participationPercent }}
            </td>
            <td [attr.rowspan]="row.rowCount" class="center-cell" style="vertical-align: middle;">
              <span [attr.aria-label]="row.isPresident ? 'Sí' : 'No'">{{ row.isPresident ? '✓' : '' }}</span>
            </td>
            <td [attr.rowspan]="row.rowCount" class="center-cell" style="vertical-align: middle;">
              <span [attr.aria-label]="row.isSecretary ? 'Sí' : 'No'">{{ row.isSecretary ? '✓' : '' }}</span>
            </td>
            <td [attr.rowspan]="row.rowCount" class="center-cell" style="vertical-align: middle;">
              <span [attr.aria-label]="row.isWorker ? 'Sí' : 'No'">{{ row.isWorker ? '✓' : '' }}</span>
            </td>
          }
        </tr>
      } @empty {
        <tr>
          <td colspan="11" class="empty-row" style="text-align: center;">Sin socios registrados.</td>
        </tr>
      }
    </tbody>
  </table>
</div>

@if (socios().length > 0) {
  <div class="socios-summary" style="margin-bottom: 3rem;">
    @if (partialLabel(); as label) {
      <span>{{ label }}: <strong>{{ formatAdjusted(totalSocios()) }}</strong></span>
    } @else {
      <span>Nº acciones totales socios: <strong>{{ formatAdjusted(totalSocios()) }}</strong></span>
      <span style="margin-left: 1.5rem;">Total acciones empresa: <strong>{{ formatShareAmount(totalEmpresa()) }}</strong></span>
    }
  </div>
}
